import userService from "@/services/auth/user.service";
import moment from "moment";
import constant from "@/common/constant";
import DOMPurify from "dompurify";
import globalService from "@/services/global.service";
import administratorAPI from "@/views/modules/administrator/administrator.api";
import store from "@/store";

const iBaseComponent = {
	props: { required: {}, email: {}, phoneNumber: {} },
	data() {
		return {
			valid: false,
			dateTimeFormat: `DD/MM/yyyy HH:mm`,
			dateFormat: "DD/MM/yyyy",
			dialog: {},
			validatorRules: {
				required: (value) => !!value || this.$t("validator.required"),
				maxLength255: (value) => {
					if (`${value}`.length > 255) {
						return this.$t("validator.max_length_255");
					}
					return true;
				},
				maxLength500: (value) => {
					if (`${value}`.length > 500) {
						return this.$t("validator.max_length_500");
					}
					return true;
				},

				notTrim: (value) => {
					// if (value || !value)
					let regex = /^[ ]+|[ ]+$/g;
					if (regex.test(`${value}`)) {
						return this.$t("validator.not_trim");
					}
					return true;
				},
				email: (value) => {
					let regex =
						/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
					if (!regex.test(`${value}`)) {
						return this.$t("validator.email");
					}
					return true;
				},
				phoneNumber: (value) => {
					let regex = /^[+]?\d$/;
					if (!regex.test(`${value}`)) {
						return this.$t("validator.phone_number");
					}
					return true;
				},
			},
			formError: false,
			m_files_icon: {
				"": "mdi-folder",
				html: "mdi-language-html5",
				js: "mdi-nodejs",
				json: "mdi-code-json",
				pdf: "mdi-file-pdf-box",
				"application/pdf": "mdi-file-pdf-box",
				png: "mdi-file-image",
				txt: "mdi-file-document-outline",
				"text/plain": "mdi-file-document-outline",
				xlsx: "mdi-file-excel",
				xls: "mdi-file-excel",
				ppt: "mdi-file-powerpoint",
				pptx: "mdi-file-powerpoint",
				docx: "mdi-file-word",
				doc: "mdi-file-word",
				zip: "mdi-folder-zip",
				rar: "mdi-folder-zip",
				tar: "mdi-folder-zip",
				gz: "mdi-folder-zip",
			},
			filterExist: false,
			isDragOver: false,
			componentLoading: {
				form: true,
				document: true,
				attachment: true,
				history: true,
				process: true,
			},
		};
	},
	computed: {
		m_rules() {
			let _rules = [];
			if (this.required) {
				_rules.push(this.validatorRules.required);
			}
			if (this.email) {
				_rules.push(this.validatorRules.email);
			}
			if (this.maxLength == 255) {
				_rules.push(this.validatorRules.maxLength255);
			} else if (this.maxLength == 500) {
				_rules.push(this.validatorRules.maxLength500);
			} else {
				_rules.push(this.validatorRules.maxLength255);
			}
			_rules.push(this.validatorRules.notTrim);
			return _rules;
		},
		formatValue() {
			if (moment(this.tempValue).isValid()) {
				return moment(this.tempValue).format(
					this.m_format || constant.format.vi_date,
				);
			} else {
				return null;
			}
		},
		customColors() {
			return store.state.customColors;
		},
		listStatus() {
			return store.state.listStatus;
		},
		currentUserInfo() {
			// safe fallback if store got issues,
			// but null currentUserInfo is gonna do re-login flow anyway
			return store.state.currentUserInfo
				? store.state.currentUserInfo
				: this.getUserInfo();
		},
		vueEnvironment() {
			return process.env.VUE_APP_ENVIRONMENT;
		},
	},
	created() {
		// this.$Progress.start();
	},
	mounted() {
		// this.$Progress.finish();
	},
	filters: {
		dateToString(date) {
			return date ? moment(date).format("DD/MM/yyyy HH:mm") : "";
		},
	},
	methods: {
		getUserInfo() {
			return userService.getUserInfo();
		},
		getBreadcrumbs() {
			let result = [];
			let currentRoute = this.$router.currentRoute;
			for (const match of currentRoute.matched) {
				if (!match.name) {
					continue;
				}
				let index = result.findIndex((e) => {
					return e.text === match.name;
				});
				let isMatchPath = currentRoute.path === match.path;
				if (currentRoute.params) {
					let filledString = match.path;
					Object.keys(currentRoute.params).forEach((key) => {
						const regex = new RegExp(`:${key}`, "g");
						filledString = filledString.replace(
							regex,
							currentRoute.params[key],
						);
					});
					isMatchPath = currentRoute.path === filledString;
				}
				if (
					match.path === `${currentRoute.path}/` ||
					currentRoute.path === `${match.path}/`
				) {
					isMatchPath = true;
				}

				let obj = {
					text: match.name,
					disabled: !!match.meta?.template || isMatchPath,
					currentPath: isMatchPath,
					to: match.path,
				};
				if (index >= 0) {
					result[index] = obj;
					continue;
				}
				result.push(obj);
			}
			return result;
		},
		errorLoad(message = this.$t("error.load")) {
			this.toastError(message);
			this.finishLoad();
		},
		errorUpdate(message = this.$t("error.update")) {
			this.toastError(message);
			this.finishLoad();
		},
		finishLoad() {
			this.loading = false;
		},
		toast(
			message = "",
			options = {
				message: message,
				type: "info",
				position: "top-right",
				duration: 3000,
				dismissible: "",
				queue: "",
				pauseOnHover: false,
				onClick: () => {},
				onDismiss: () => {},
			},
		) {
			this.$toast.default(message, options);
		},
		toastError(
			message = "",
			options = {
				message: message,
				type: "error",
				position: "top-right",
				duration: 3000,
				dismissible: "",
				queue: "",
				pauseOnHover: false,
				onClick: () => {},
				onDismiss: () => {},
			},
		) {
			this.toast(message, options);
		},
		toastSuccess(
			message = "",
			options = {
				message: message,
				type: "success",
				position: "top-right",
				duration: 3000,
				dismissible: "",
				queue: "",
				pauseOnHover: false,
				onClick: () => {},
				onDismiss: () => {},
			},
		) {
			this.toast(message, options);
		},
		getIdFromValue(value = "") {
			return this.nonAccentVietnamese(value)
				.toLocaleLowerCase()
				.split(/[^a-zA-Z0-9]+/)
				.join("_");
		},
		nonAccentVietnamese(value) {
			let str = `${value}`;
			str = str.toLowerCase();
			str = str.replace(
				/\u00E0|\u00E1|\u1EA1|\u1EA3|\u00E3|\u00E2|\u1EA7|\u1EA5|\u1EAD|\u1EA9|\u1EAB|\u0103|\u1EB1|\u1EAF|\u1EB7|\u1EB3|\u1EB5/g,
				"a",
			);
			str = str.replace(
				/\u00E8|\u00E9|\u1EB9|\u1EBB|\u1EBD|\u00EA|\u1EC1|\u1EBF|\u1EC7|\u1EC3|\u1EC5/g,
				"e",
			);
			str = str.replace(/\u00EC|\u00ED|\u1ECB|\u1EC9|\u0129/g, "i");
			str = str.replace(
				/\u00F2|\u00F3|\u1ECD|\u1ECF|\u00F5|\u00F4|\u1ED3|\u1ED1|\u1ED9|\u1ED5|\u1ED7|\u01A1|\u1EDD|\u1EDB|\u1EE3|\u1EDF|\u1EE1/g,
				"o",
			);
			str = str.replace(
				/\u00F9|\u00FA|\u1EE5|\u1EE7|\u0169|\u01B0|\u1EEB|\u1EE9|\u1EF1|\u1EED|\u1EEF/g,
				"u",
			);
			str = str.replace(/\u1EF3|\u00FD|\u1EF5|\u1EF7|\u1EF9/g, "y");
			str = str.replace(/\u0111/g, "d");
			str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, "");
			str = str.replace(/\u02C6|\u0306|\u031B/g, "");
			return `${str}`;
		},
		match(item, value) {
			let keys = Object.keys(item);
			for (let key of keys) {
				if (
					this.nonAccentVietnamese(`${item[key]}`).match(
						this.nonAccentVietnamese(`${value}`),
					)
				) {
					return true;
				}
			}
			return false;
		},

		/**
		 *
		 * @param {String} item
		 * @param {String} value
		 * @returns {Array|boolean}
		 */
		matchString(item, value) {
			return this.nonAccentVietnamese(`${item}`).match(
				this.nonAccentVietnamese(`${value}`),
			);
		},
		getAvatarText(value, number = 2) {
			if (!value) {
				return constant.default_organization;
			}
			let tmp = `${value}`;
			let values = tmp.split(constant.space);
			let index = 0;
			let result = "";
			while (index < values.length && index < number) {
				result = result.concat(values[index++].charAt(0).toUpperCase());
			}
			return result;
		},
		isObject(value) {
			if (typeof value == "object") return true;
			return false;
		},
		closeDialog() {
			this.$emit(constant.keys.close, true);
			// this.$destroy();
		},
		cancelDialog() {
			this.$emit(constant.keys.cancel, true);
		},
		saveDialog() {
			this.$emit(constant.keys.save, true);
		},
		onCloseDialog(value = true) {
			if (value) {
				for (let key in this.dialog) {
					this.dialog[key] = false;
				}
			}
		},
		onSaveDialog(value = true) {
			if (value) {
				this.onCloseDialog();
				// this.initialize();
			}
		},
		confirmDeleteDialog() {
			this.$emit(constant.keys.confirmDelete, true);
		},

		formatDate_V1(value) {
			let _date = moment(value);
			if (!_date.isValid()) return null;
			return moment(value).format("DD/MM/yyyy");
		},
		checkTrueFalse(value) {
			if (value == true) return "Có";
			return "Không";
		},
		///// xuất file xlsx
		getJsonFields(headers) {
			let newObj = {};
			let newHeader = [];
			let newHeaders = Object.assign([], headers);
			for (const head of newHeaders) {
				if (head.value.includes("action")) {
					newHeaders.pop();
				}
				if (head.value.includes("Date")) {
					newObj = {
						label: head.text,
						field: head.value,
						dataFormat: this.formatDate_V1,
					};
				} else if (head.value.includes("Time")) {
					newObj = {
						label: head.text,
						field: head.value,
						dataFormat: this.formatDate_V1,
					};
				} else if (head.value.includes("Active")) {
					newObj = {
						label: head.text,
						field: head.value,
						dataFormat: this.checkTrueFalse,
					};
				} else {
					newObj = {
						label: head.text,
						field: head.value,
					};
				}
				newHeader.push(newObj);
			}

			return newHeader;
		},
		formatDate(value, dateFormat = "DD/MM/yyyy HH:mm") {
			if (!value) {
				return "";
			}
			return moment(value).format(dateFormat);
		},
		async handleButtonClick(event) {
			await event();
		},

		/**
		 *
		 * @param {Object} response
		 * @returns {boolean}
		 */
		preHandleResponse(response) {
			if (!response) {
				this.toastError(response);
				return false;
			}
			if (!response.state) {
				this.toastError(response.message);
				return false;
			}
			return true;
		},
		deleteItem() {
			this.dialog.delete = true;
		},
		onConfirmDelete() {
			this.dialog.delete = false;
		},
		cancel() {
			this.onCloseDialog();
		},
		createChild() {
			this.dialog.edit = true;
		},
		editItem() {
			this.dialog.edit = true;
		},

		/**
		 *
		 * @param {string} value
		 * @returns {boolean}
		 */
		notTrim(value) {
			let regex = /^[ ]+|[ ]+$/g;
			return !regex.test(`${value}`);
		},

		/**
		 *
		 * @param {string} value
		 * @returns {boolean}
		 */
		validText(value) {
			if (`${value}`.length > constant.values.MAX_LENGTH) {
				return false;
			}
			return true;
		},

		validRequiredText(value) {
			if (!value || `${value}`.length > constant.values.MAX_LENGTH) {
				return false;
			}
			return true;
		},
		redirectBack(n = -1) {
			this.$router.go(n);
		},

		downloadBlob(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		},

		sanitizeHTML(content) {
			return DOMPurify.sanitize(content);
		},

		readFileAsText(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsText(file);
			});
		},

		canAccessByRole(roles, userRoles) {
			if (!roles?.length) {
				return true;
			}
			if (!userRoles?.length) {
				return false;
			}
			return userRoles.some((e) => roles.includes(e.roleType));
		},

		async onDuplicateRequest(id) {
			try {
				let response = await globalService.postData_Async(
					administratorAPI.API_CopyPYC(),
					[id],
				);
				if (!response.state) {
					this.toastError(
						response?.message ||
							this.$t("error.copy_request_data_fail"),
					);
					return;
				}
				let clone_data = response.data;
				if (clone_data) {
					for (let key in clone_data) {
						this.$router.push({
							path: `/phieu-yeu-cau/${clone_data[key]}/chi-tiet`,
						});
					}
				}
			} catch (e) {
				console.error("onDuplicateRequest-> e", e);
			}
		},
		async onDuplicateRequestFromPreviousPYC(id, idFrom) {
			try {
				let response = await globalService.postData_Async(
					administratorAPI.API_CopyFromPreviousPYC(idFrom),
					[id],
				);
				if (!response.state) {
					this.toastError(this.$t("error.copy_request_data_fail"));
					return;
				}
				let clone_data = response.data;
				if (clone_data) {
					for (let key in clone_data) {
						this.$router.push({
							path: `/phieu-yeu-cau/${clone_data[key]}/chi-tiet`,
						});
					}
				}
			} catch (e) {
				console.error("onDuplicateRequestFromPreviousPYC-> e", e);
			}
		},

		onValidateHSMSignPayload(payload, keysToValidate) {
			const presetKeys = {
				// payload config
				uuidHsm: "UUID",
				usernameHsm: "tên người dùng",
				password1Hsm: "mật khẩu cấp 1",
				password2Hsm: "mật khẩu cấp 2",
				taxCodeHsm: "mã định danh",
				// payload sign
				uuid: "UUID",
				username: "tên người dùng",
				password1: "mật khẩu cấp 1",
				password2: "mật khẩu cấp 2",
				taxCode: "mã định danh",
			};
			let result = true;
			for (const key of keysToValidate) {
				if (!this.validRequiredText(payload[key])) {
					this.toastError(`Thiếu ${presetKeys[key]}`);
					result = false;
				}
			}
			return result;
		},

		mergeObjectsWithSameKey(objA, objB) {
			for (const key in objB) {
				if (Object.prototype.hasOwnProperty.call(objA, key)) {
					objA[key] = objB[key];
				}
			}
			return objA;
		},

		async getAllRequestGroup() {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_CreateRequestGroup(),
				);
				if (!response?.data) {
					return;
				}
				let list = response.data.filter((entry) => {
					return !entry.isDelete && entry.isActive;
				});
				return list?.sort(
					(a, b) =>
						moment(b.createdDate).toDate() -
						moment(a.createdDate).toDate(),
				);
			} catch (e) {
				console.error("getRequestGroup", e);
				return [];
			}
		},
		async getAllRequestTypes() {
			try {
				const response = await globalService.getData_Async(
					administratorAPI.API_GetAllRequestType(),
				);
				const list = response?.data?.filter(
					(entry) => !entry.isDelete && entry.isActive,
				);

				return list?.sort(
					(a, b) =>
						moment(b.createdDate).toDate() -
						moment(a.createdDate).toDate(),
				);
			} catch (e) {
				console.error("getRequestTypes", e);
			}
		},
		async getAllOrganzation() {
			try {
				const response = await globalService.getData_Async(
					administratorAPI.API_FindAllOrganizationRole(),
				);
				if (response?.state) {
					const list = response.data?.filter(
						(entry) => !entry.isDelete && entry.isActive,
					);
					list.forEach((item) => {
						if (item?.path) {
							item.path = item.path.replace(" - MOBIFONE", "");
						}
					});
					return list;
				}
			} catch (e) {
				console.error("getAllOrganzation", e);
			}
		},


		// mimicking Windows explorer behavior
		sortingFileName(a, b, isDesc) {
			// Handle null/undefined/empty values
			if (!a || !b) {
				if (!a && !b) return 0;
				return !a ? 1 : -1; // Nulls/empty last
			}

			// Helper to split string into parts (text or number)
			const splitIntoParts = (str) => {
				const parts = [];
				let current = "";
				let isNumber = false;

				for (let i = 0; i < str.length; i++) {
					const char = str[i];
					const isDigit = /\d/.test(char);

					if (i === 0) {
						isNumber = isDigit;
						current = char;
					} else if (isDigit === isNumber) {
						current += char;
					} else {
						parts.push(
							isNumber
								? parseInt(current, 10)
								: this.nonAccentVietnamese(
									current,
								).toLocaleUpperCase(),
						);
						current = char;
						isNumber = isDigit;
					}
				}
				// Push the last part
				parts.push(
					isNumber
						? parseInt(current, 10)
						: this.nonAccentVietnamese(current).toLocaleUpperCase(),
				);
				return parts;
			};

			const aParts = splitIntoParts(a);
			const bParts = splitIntoParts(b);

			// Compare parts sequentially
			for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
				const aPart = aParts[i];
				const bPart = bParts[i];

				// Both parts are numbers
				if (typeof aPart === "number" && typeof bPart === "number") {
					if (aPart < bPart) return isDesc ? 1 : -1;
					if (aPart > bPart) return isDesc ? -1 : 1;
				}
				// Both parts are strings
				else if (typeof aPart === "string" && typeof bPart === "string") {
					const comparison = aPart.localeCompare(bPart);
					if (comparison !== 0) return isDesc ? -comparison : comparison;
				}
				// Mixed types: numbers come before strings (Windows behavior)
				else {
					return typeof aPart === "number"
						? isDesc
							? 1
							: -1
						: isDesc
							? -1
							: 1;
				}
			}

			// If one string has more parts, it comes after (or before in descending)
			if (aParts.length < bParts.length) return isDesc ? 1 : -1;
			if (aParts.length > bParts.length) return isDesc ? -1 : 1;
			return 0;
		},
	},
};
export default iBaseComponent;
